export default __webpack_public_path__ + "static/media/viewProfile.af243cbe.svg";